var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pot-wrapper" }, [
    _c(
      "div",
      { staticClass: "sk-panel mb-4" },
      [
        _vm._m(0),
        _vm.formulaExpression
          ? _c("div", { staticClass: "pot-formula-row mb-3" }, [
              _vm._m(1),
              _c("div", { staticClass: "pot-formula-body" }, [
                _c("span", { staticClass: "pot-formula-value" }, [
                  _vm._v(_vm._s(_vm.formulaExpression)),
                ]),
                _vm.computedFormulaPreview
                  ? _c("span", { staticClass: "pot-formula-preview" }, [
                      _vm._v(
                        "\n          = " +
                          _vm._s(_vm.computedFormulaPreview) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
            ])
          : _vm._e(),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "sk-table pot-table",
            attrs: {
              data: _vm.overrides,
              border: "",
              "empty-text": _vm.emptyText,
            },
          },
          [
            _c("el-table-column", {
              attrs: { label: "Biến", align: "center", width: "65" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "pot-alias" }, [
                        _vm._v(_vm._s(row.alias)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Tên khoản phụ", "min-width": "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "pot-name" }, [
                        _vm._v(_vm._s(row.principalName)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Giá gốc", align: "right", width: "135" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c("span", { staticClass: "pot-money" }, [
                        _vm._v(_vm._s(_vm.formatMoney(row.originalPrice))),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Giá riêng HS", align: "right", width: "155" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "div",
                        { staticClass: "pot-price-cell" },
                        [
                          _c(
                            "span",
                            {
                              class: [
                                "pot-money",
                                {
                                  "pot-money--custom":
                                    Number(row.price) !==
                                    Number(row.originalPrice),
                                },
                              ],
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formatMoney(row.price)) +
                                  "\n            "
                              ),
                            ]
                          ),
                          Number(row.price) !== Number(row.originalPrice)
                            ? _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content:
                                      "Giá đã bị ghi đè riêng cho học sinh này",
                                    placement: "top",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "el-icon-edit-outline pot-warn-icon",
                                  }),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "SL", align: "center", width: "60" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "span",
                        {
                          class: [
                            "pot-qty",
                            {
                              "pot-qty--custom":
                                Number(row.quantity) !==
                                Number(row.originalQuantity),
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.formatQuantity(row.quantity)) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Đơn vị", align: "center", width: "85" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "span",
                        {
                          class: [
                            "pot-unit",
                            {
                              "pot-unit--custom": row.unit !== row.originalUnit,
                            },
                          ],
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(row.unit || "—") +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Giảm giá", align: "center", width: "105" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      row.discount
                        ? [
                            _c("span", { staticClass: "pot-discount-tag" }, [
                              row.discountType === "PERCENT"
                                ? _c("span", [
                                    _vm._v(
                                      "-" + _vm._s(row.discountNumber) + "%"
                                    ),
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "-" +
                                        _vm._s(
                                          _vm.formatMoney(row.discountNumber)
                                        )
                                    ),
                                  ]),
                            ]),
                          ]
                        : _c("span", { staticClass: "pot-text-muted" }, [
                            _vm._v("—"),
                          ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: { label: "Trạng thái", align: "center", width: "115" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ row }) {
                    return [
                      _c(
                        "el-tag",
                        {
                          staticClass: "pot-status-tag",
                          attrs: {
                            type: _vm.isDefault(row) ? "info" : "warning",
                            size: "mini",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.isDefault(row) ? "Mặc định" : "Đã ghi đè"
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pot-actions mt-3" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small", icon: "el-icon-edit" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("edit")
                  },
                },
              },
              [_vm._v("\n        Sửa giá khoản phụ\n      ")]
            ),
            _vm.hasCustomPrice
              ? _c(
                  "el-button",
                  {
                    attrs: {
                      type: "warning",
                      size: "small",
                      icon: "el-icon-refresh-left",
                      loading: _vm.resetting,
                    },
                    on: { click: _vm.handleReset },
                  },
                  [_vm._v("\n        Reset về mặc định\n      ")]
                )
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sk-panel-head" }, [
      _c("div", { staticClass: "sk-panel-icon sk-panel-icon--warning" }, [
        _c("i", { staticClass: "el-icon-s-operation" }),
      ]),
      _c("div", [
        _c("p", { staticClass: "sk-panel-title" }, [
          _vm._v("Chi tiết khoản phụ"),
        ]),
        _c("p", { staticClass: "sk-panel-subtitle" }, [
          _vm._v(
            "\n          Các khoản phụ trong công thức. Giá riêng khác giá gốc sẽ được đánh dấu.\n        "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pot-formula-header" }, [
      _c("i", { staticClass: "el-icon-cpu pot-formula-icon" }),
      _c("span", { staticClass: "pot-formula-label" }, [
        _vm._v("Công thức tính toán:"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }